import { axiosInstance as request } from '@/api/rest.service'

export const getTableData = () => request.get('/fte-fields')
export const createNewField = payload => request.post('/fte-fields', payload)
export const updateField = (id, payload) => request.patch(`/fte-fields/${id}`, payload)
export const getDeleteConfirmation = id => request.get(`/fte-fields/${id}/delete-confirmation`)
export const deleteField = id => request.delete(`/fte-fields/${id}`)
